import React from 'react';
import { Star, Quote } from 'lucide-react';

const TestimonialsGrid = () => {
  const reviews = [
    { name: "Rajesh Sharma", shop: "Sharma General Store, Delhi", tag: "10 second billing", text: "Pehle bill banane mein 2 minute lagte the. Ab sirf 10 second mein ho jata hai. Customers bhi khush hain!", initial: "RS", color: "bg-emerald-600" },
    { name: "Priya Patel", shop: "Patel Kirana, Mumbai", tag: "30% more orders", text: "QR menu se ab customers khud order kar lete hain. Staff ki zarurat kam ho gayi aur orders badh gaye.", initial: "PP", color: "bg-emerald-600" },
    { name: "Mohammed Khan", shop: "Khan Store, Hyderabad", tag: "Zero stockouts", text: "Inventory management bahut easy ho gaya. Pehle stock khatam hone ka pata hi nahi chalta tha.", initial: "MK", color: "bg-emerald-600" },
    { name: "Sunita Devi", shop: "Sunita Provisions, Patna", tag: "Easy for everyone", text: "Mere 70 saal ke sasur ji bhi use kar lete hain. Itna simple hai. Daily reports WhatsApp pe aa jati hain.", initial: "SD", color: "bg-emerald-600" },
    { name: "Amit Verma", shop: "Verma Mart, Lucknow", tag: "Better recovery", text: "Customer credit (udhar) manage karna ab bahut easy hai. Auto reminder bhi chale jate hain.", initial: "AV", color: "bg-emerald-600" },
    { name: "Lakshmi Narayan", shop: "Sri Balaji Stores, Chennai", tag: "GST compliant", text: "GST invoice automatic banta hai. CA ko bhi bhenjne mein koi problem nahi hoti. Sab digital!", initial: "LN", color: "bg-emerald-600" }
  ];

  return (
    <section className="py-24 bg-slate-50 px-4">
      <div className="max-w-7xl mx-auto text-center mb-16">
        <h2 className="text-emerald-600 font-bold uppercase text-xs mb-3">Testimonials</h2>
        <h3 className="text-4xl md:text-5xl font-black text-slate-900 mb-4 tracking-tight">Trusted by 1000+<br />Shop Owners Across India</h3>
        <p className="text-gray-500">Don't just take our word for it. Here's what real kirana store owners say.</p>
      </div>

      <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((rev, i) => (
          <div key={i} className="bg-white p-8 rounded-2xl shadow-sm relative group hover:shadow-xl transition-all">
            <div className="flex justify-between items-start mb-6">
              <div className="flex text-yellow-400 gap-1">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" />)}
              </div>
              <Quote className="text-emerald-100 group-hover:text-emerald-500 transition-colors" size={32} />
            </div>
            <div className="inline-block px-3 py-1 bg-emerald-50 text-emerald-700 text-[10px] font-bold rounded-full mb-4 uppercase">
              {rev.tag}
            </div>
            <p className="text-slate-600 text-sm italic mb-8 leading-relaxed">"{rev.text}"</p>
            <div className="flex items-center gap-4">
              <div className={`${rev.color} w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm`}>{rev.initial}</div>
              <div className="text-left">
                <p className="font-bold text-sm text-slate-900">{rev.name}</p>
                <p className="text-[10px] text-gray-500">{rev.shop}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsGrid;